<template>
    <va-select
        :label="$t('catalog.product.categories')"
        v-model="multiSelectedCat"
        textBy="description"
        :options="options"
        :error="error"
        multiple
    />
</template>

<script>
export default {
    props: ['selected'],
    data() {
        return {
            error:false,
            multiSelectedCat: [],
        }
    },
    created(){
        if(this.options.length == 0){
            this.$store.dispatch('getCategories');
        }
    },
    computed:{
        options(){
            return this.$store.state.categories.selectOptions;
        },
        expandedOpt(){
            return this.$store.state.categories.expandedOptions;
        },
        categories(){
            return this.$store.state.categories.categories;
        },

    },
    watch: {
        selected(t,f){
            this.getSelected();
        },
        options(t,f){
            this.getSelected();
        },
        multiSelectedCat(t,f){
            var arr = [];
            for(var i in t){
                arr.push(t[i].id);
            }
            this.$emit('input',arr);
        }
    },
    methods : {
        getSelected(){
            var arr = []
            for(var i in this.selected){
                for(var o in this.options){
                    if(this.selected[i].id == this.options[o].id){
                        this.selected[i].description = this.options[o].description;
                        arr.push(this.selected[i]);
                    }
                }
            }
            this.multiSelectedCat = arr;
        }
    }
}
</script>
